var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'discovery-stats-chart-source',
    { 'discovery-stats-chart-source--active': _vm.isActive },
  ]},[_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }